const expletives: string[] = [
    'boner',
    'booty',
    'choad',
    'cunt',
    'darky',
    'fagot',
    'fucck',
    'fuck',
    'fugly',
    'fuuck',
    'gook',
    'gyppo',
    'gypsy',
    'jewed',
    'jigga',
    'jizz',
    'kike',
    'kkk',
    'kyke',
    'lesbo',
    'nigar',
    'nigg',
    'nigga',
    'nigs',
    'peni5',
    'poop',
    'pu55i',
    'pu55y',
    'queef',
    'raper',
    'shit',
    'shhit',
    'shits',
    'slutt',
    'titty',
    'titties',
    'whore',
]

export { expletives }
